import { FC } from 'react';
import { Box } from '@mui/material';
import { ProCrownIcon } from '../../icons/ProCrownIcon';
import { ProBadgeTooltip } from './pro-badge-tooltip.component';

interface ProBadgeCrownProps {
	size?: 'large' | 'medium';
}

const SIZE_CONFIG = {
	medium: {
		crownSize: '16px',
		badgeSize: '24px',
	},

	large: {
		crownSize: '22px',
		badgeSize: '34px',
	},
};

export const ProBadgeCrown: FC<ProBadgeCrownProps> = ({ size = 'medium' }) => {
	const config = SIZE_CONFIG[size];

	return (
		<ProBadgeTooltip>
			<Box
				sx={{
					display: 'inline-block',
					padding: '1px',
					background:
						'conic-gradient(from 30deg, rgb(255, 205, 78) 0%, rgb(253, 246, 125) 20%, rgb(253, 246, 125) 40%, rgb(247, 195, 77) 60%, rgb(255, 255, 255) 74%, rgb(253, 186, 61) 100%)',
					clipPath: `shape(from 84.41% 75%,curve to 63.14% 90.45% with 79.39% 90.45%,line to 36.86% 90.45%,curve to 15.59% 75% with 20.61% 90.45%,line to 7.47% 50%,curve to 15.59% 25% with 2.45% 34.55%,line to 36.86% 9.55%,curve to 63.14% 9.55% with 50% 0%,line to 84.41% 25%,curve to 92.53% 50% with 97.55% 34.55%)`,
					position: 'relative',

					'&::before': {
						content: '""',
						position: 'absolute',
						top: 0,
						left: 0,
						width: '60%',
						height: '100%',
						background:
							'linear-gradient(120deg, rgba(255,255,255,0.0) 0%, rgba(255,255,255,0.6) 50%, rgba(255,255,255,0.0) 100%)',
						transform: 'translateX(-110%) skewX(-20deg)',
						zIndex: 1,
					},

					'&:hover': {
						'&::before': {
							animation: 'shine 1s linear',
						},
					},

					'@keyframes shine': {
						'0%': { transform: 'translateX(-110%) skewX(-20deg)' },
						'100%': { transform: 'translateX(260%) skewX(-20deg)' },
					},
				}}
			>
				<Box
					sx={{
						width: config.badgeSize,
						aspectRatio: 1,
						background:
							'#FFCE4E conic-gradient(from 0deg at 50% 50%, #ffffff1a 0%, #ffffff73 5%, #ffffff1a 13%, #ffffff73 22%, #ffffff1a 30%, #ffffff73 42%, #ffffff1a 46%, #ffffff73 50%, #ffffff1a 54%, #ffffff73 58%, #ffffff1a 69%, #ffffff73 78%, #ffffff1a 87%, #ffffff73 95%, #ffffff1a 100%)',
						clipPath: `shape(from 84.41% 75%,curve to 63.14% 90.45% with 79.39% 90.45%,line to 36.86% 90.45%,curve to 15.59% 75% with 20.61% 90.45%,line to 7.47% 50%,curve to 15.59% 25% with 2.45% 34.55%,line to 36.86% 9.55%,curve to 63.14% 9.55% with 50% 0%,line to 84.41% 25%,curve to 92.53% 50% with 97.55% 34.55%)`,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<ProCrownIcon width={config.crownSize} height={config.crownSize} />
				</Box>
			</Box>
		</ProBadgeTooltip>
	);
};
